<template>
    <div id="aviseme-container">
      <Header :home="false" :logged="logged" :arealogada="true"/>
      <modalvalidaemail :key="'modalvalidaemail-'+keyModalValidaEmail" :tipo="'aviseme'" @cancelaValidacaoEmail="cancelaValidacaoEmail" @confirmaValidacaoEmail="confirmaValidacaoEmail"/>
      <b-modal
      ref="confirmaSemCertificado"
      size="x1"
      title="Atenção"
      @ok="redirecionaPainel"
      no-close-on-backdrop
      no-close-on-esc
    >
    <template #modal-header="">
      <h5>Atenção</h5>
    </template>
      Para utilizar o serviço de Avise-me é necessário estar logado por meio de Certificado Digital ICP-Brasil ou niveis Prata ou Ouro via acesso .GOV.BR
    </b-modal>
    <b-modal ref="erroPush" id="aviseme-erroPushModal"
        title="Atenção"
        :hide-header-close="true"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
        hide-footer>
      <div v-html="erroPushMsg"></div>
      <div class="d-flex justify-content-between mt-5">
        <b-button class="modal-btn-voltar" @click="cancelaErroPush">Voltar ao Painel</b-button>
        <b-button class="modal-btn-prosseguir" @click="confirmaErroPush">Prosseguir</b-button>
      </div>
    </b-modal>
      <div
        class="text-center"
        v-if="loading"
        style="
          background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
          width: 100%;
          height: 100%;
          position: absolute;
          display: block;
          z-index: 10002;
          margin: 0;
          top: 0;
          padding-top: 20%;
        "
      >
        <b-spinner
          variant="primary"
          style="width: 3rem; height: 3rem"
          label="Text Centered"
        ></b-spinner>
        <br /><span style="color: #004e86">Processando Aguarde...</span>
      </div>
      <b-modal
          ref="cancelar_pedido"
          title="Atenção"
      >
          <p v-html="mensagem"></p>
          <p>
            <b-form-textarea
            v-model="motivo_cancelamento"
            placeholder="Digite o motivo do cancelamento"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          </p>
          <template #modal-footer>
          <div class="w-100">
            <b-button
              variant="danger"
              size="sm"
              class="float-left"
              @click="fechar_modal"
            >
              Cancelar Ação
            </b-button>
            <b-button
              
              variant="primary"
              size="sm"
              class="float-right"
              @click="efetua_cancelamento_pedido"
              :disabled="carregando"
            >
              Cancelar Pedido
            </b-button>
          </div>
        </template>
      </b-modal>
      <b-modal ref="erro" :title="erro.titulo" @hidden="resetarMsg">
        <p>{{ this.erro.msg }}</p>
      </b-modal>
      <div id="painel" class="container-fluid">
        <b-row>
          <b-col cols="12" md="4" lg="3" v-if="show" style="padding: 0;" class="espaco-menu">
            <Menu class="d-none d-xl-block" />
          </b-col>
          <b-col cols="12" md="8" lg="9" class="flex" style="padding: 0;">
            <b-container fluid id="painelcontainerfluid">
              <!-- <h1>Pedidos de anuência a títulos protestados</h1> -->
              <a
                      id="dwnldLnk"
                      download="anuencia"
                      style="display: none"
                    />
                    <a
                      id="anexo"
                      download="anexo"
                      style="display: none"
                    />
              <arealogadapesquisa :colunasMobile="colunasMobile" @filtrarBusca="filtrarBusca" :resultado="items" :colunas="colunas" :hasFilter="false"  :title="'Avise-me! - Meus avisos'" @chamar-funcao="executarFuncao"/>
              <div class="loading">
                <b-spinner
                  variant="primary"
                  style="width: 3rem; height: 3rem"
                  label="Large Spinner"
                  v-if="loading"
                ></b-spinner>
              </div>
            </b-container>
          </b-col>
        </b-row>
      </div>
      
      <footersite class="d-none d-xl-block" />
        <footersitemobile class="d-block d-xl-none"/>
    </div>
  </template>
  
  
  <script>
  // import axios from "axios"
  import Header from "../../components/Header";
  import API from "../../services/api";
  import Menu from "../../template/Menu";
  import { TheMask } from "vue-the-mask";
  import arealogada from "@/components/arealogada/index.vue";
  import arealogadapesquisa from "@/components/arealogada/pesquisa/index.vue";
  import modalvalidaemail from "@/components/modal/valida-email";
  import footersite from "@/components/footersite";
  import footersitemobile from "@/components/footersite/index_mobile";

  //import Modal from '../../components/modal/Confmodal'
  
  export default {
    components: {
      Header,
      Menu,
      TheMask,
      arealogada,
      arealogadapesquisa,
      modalvalidaemail,
      footersite,
      footersitemobile

      //Modal,
    },
    data() {
      return {
        mensagem: null,
        cd_pedido_atual: null,
        motivo_cancelamento:null,
        carregando : false,
        loading: true,
        perPage: 0,
        currentPage: 1,
        dismissSecs: 5,
        dismissCountDownDOC: 0,
        empresaCredoraSelected:null,
        infoModal: {
          id: "info-modal",
          title: "",
          content: "",
          conteudo: "",
        },
        infoModalDeletar: {
          id: "info-modal-deletar",
          title: "",
          conteudo: "",
        },
        // filterFields:[
        //   {key:"nm_devedor",label:"Nome do devedor:",placeholder:"Nome devedor",size:"1", inputType:'',},
        //   {key:"ocorrencia",label:"Ocorrência:",placeholder:"XXXXXXXXX",size:"1", inputType:'',},
        //   {key:"nm_nr_documento_devedor",label:"Documento do devedor:",placeholder:"XXXXXXXXX",size:"1", inputType:'', mask:{cpf:'###.###.###-##', cnpj:'##.###.###/####-##'}},
        //   {key:"numero",label:"Número:",placeholder:"Nº documento",size:"1", inputType:'',},
        //   {key:"nosso_numero",label:"Nosso número:",placeholder:"XXXXXXXXX",size:"1", inputType:'',},
        //   {key:"dt_emissao",label:"Data emissão:",placeholder:"DD/MM/AAAA",size:"1", inputType:'',},
        //   {key:"dt_vencimento",label:"Data vencimento:",placeholder:"DD/MM/AAAA",size:"1", inputType:'',},
        //   {key:"vl_titulo",label:"Valor do título:",placeholder:"R$",size:"1", isCurrency:true, inputType:'',},
        //   {key:"vl_protesto",label:"Valor a protestar:",placeholder:"R$",size:"1", isCurrency:true, inputType:'',},
        // ],
        colunas: [
          { key: "dt_cadastro", label: "Data do aviso", sortable: true, size:'1.5fr'},
          { key: "nm_sacador", label: "Credor", sortable: true, size:'2fr', exibicao:true },
          { key: "nm_nr_documento_sacador", label: "Doct. Credor", sortable: true, size:'2fr', maskDoc: true, exibicao:true },
          { key: "nm_nr_titulo", label: "Nº Título", sortable: true, size:'0.5fr' },
          { key: "sg_especie", label: "Espécie", sortable: true, size:'0.5fr' },
          { key: "dt_vencimento", label: "Data de Vencimento", sortable: true, size:'1fr' },
          { key: "vl_protesto", label: "Valor a protestar", sortable: true, size:'1.5fr', isCurrency:true},
          { key: "ds_cartorio", label: "Comarca Cartório", sortable: true, size:'1fr' },
          { key: "dt_protocolo", label: "Protocolo Data", sortable: true, size:'1fr'},
       
        ],
        colunasMobile: [
          {label:'Nº Pedido',key:'cd_pedido',sortable:false,size:'0.75fr'},
          {label:'Pesquisado',key:'nm_pesquisado',sortable:true,size:'1.5fr'},
          {key: "actions", label: "Exibir", sortable: false, size:"0.5fr"}
      ],
        fields: [
          { key: "cd_anuencia", label: "Nº Anuência ", sortable: false },
          { key: "nm_nr_titulo", label: "Nº Título", sortable: true },
          { key: "sg_especie", label: "Espécie", sortable: true },
          { key: "NomeCartorio", label: "Cartório", sortable: true },
          { key: "nm_devedor", label: "Devedor", sortable: true },
          { key: "documento_devedor", label: "Documento", sortable: true },
          { key: "dt_cadastro", label: "Cadastrado em", sortable: true },
          { key: "vl_titulo", label: "Valor Título", sortable: true },
          { key: "vl_protesto", label: "Valor Protestado", sortable: true },
          { key: "ds_status", label: "Status Solicitação", sortable: true },
          { key: 'Exibir', label: 'Exibir',sortable: false },
          { key: "actions", label: "Ação" },
        ],
        items: [],
        form:{},
        // form: {
        //   nomeDevedor: "",
        //   dtSolcitacao: "",
        //   nrtituloDevedor: "",
        //   docDevedor: "",
        // },
        empresaSelecionada: "",
        statusSelecionado: "",
        empresaCredora: [],
        statusSolicitacao: [],
        dadosDevedor: [],
        show: true,
        VempresaCredora: true,
        itemsSelecionados: [],
        erro: { msg: "", titulo: "" },
        usuario:{},
        erroPushMsg:"",
        keyModalValidaEmail:0,
      };
    },
    computed: {
      rows() {
        return this.items.length;
      },
      _dataMaxima() {
        return new Date().toLocaleDateString().split("/").reverse().join("-");
      },
    },
    async created() {
      let loginComCertifiicado = 
      localStorage.getItem("sg_tipo_documento") && 
      localStorage.getItem("SSL_CLIENT_S_DN_CN") && 
      localStorage.getItem("nm_tipo_certificado") &&
      localStorage.getItem("SSL_CLIENT_S_DN") &&
      localStorage.getItem("SSL_CLIENT_V_START") &&
      localStorage.getItem("SSL_CLIENT_V_END") 

      let govLogin = (localStorage.getItem('pxppwiru9') != undefined && localStorage.getItem('pxppwiru9') != null);
      let allowedGov = (govLogin ? ['2','3'].includes(localStorage.getItem("lhwvzhds3")) : false)
      let self = this

      
      setTimeout(function (){

        if((!govLogin || !allowedGov) && !loginComCertifiicado){
          // self.$refs["confirmaSemCertificado"].show();
          self.loading = false;
        }
       
      },1)

      // if((govLogin && allowedGov) || loginComCertifiicado) {
        let dados = await self.getDados();
        setTimeout(() => {
          // console.log(self.usuario.ic_email_validado);
          if(self.usuario.ic_email_validado != 1){
              self.loading = false;
              self.erroPushMsg = `<p>Que bom que está aqui, você já fez a adesão ao avise-me, mas ainda não ativou a sua conta.</p>
                                  <p>Agora basta clicar em prosseguir e usar o token que vai receber em seu email para validar a sua conta.</p>
                                  <p>Os avisos só serão ativos após essa confirmação de email.</p>`
              self.$refs['erroPush'].show();
          }
          else{
            this.pesquisar();
            this.informacoesCertificado();
            this.logged = true;
            this.empresaCredoraSelected = localStorage.getItem("usrCpf")
            const token = localStorage.getItem('jwtToken')
            API.post("usuario/getPermicaoServico", { token }).then((res) =>{
              if(!res.data[0].ic_adesao_aviseme)this.$router.push({name:'avise-me/adesao'})
            });
          }
        }, 10);
      // }

    },
    filters: {
      moeda: function (value) {
        if (value) {
          return parseFloat(value).toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          });
        }
        return "R$ 0,00";
      },
      dataHora: function (value) {
        if (value !== "" && value !== undefined && value !== null) {
          let date = new Date(value);
          return date.toLocaleDateString("pt-BR", {
            hour: "numeric",
            minute: "numeric",
            year: "numeric",
            month: "numeric",
            day: "numeric",
          });
        }
        return "";
      },
      data: function (value) {
        if (value !== "" && value !== undefined && value !== null) {
          let date = new Date(value);
          return date.toLocaleDateString("pt-BR", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
          });
        }
        return "";
      },
      documento: function (entrada) {
        if (entrada) {
          let tamanho = entrada.toString().length,
            padraoCPF = /(\d{3})(\d{3})(\d{3})(\d{2})/,
            padraoCNPJ = /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            subCPF = "$1.$2.$3-$4",
            subCNPJ = "$1.$2.$3/$4-$5";
  
          if (tamanho == 11) {
            return entrada.replace(padraoCPF, subCPF);
          } else if (tamanho == 14) {
            return entrada.replace(padraoCNPJ, subCNPJ);
          } else {
            return "";
          }
        }
        return "";
      },
      nomeCartorio: function (entrada) {
        if (entrada) {
          return entrada.split(" / ")[0];
        }
        return "";
      },
      cidadeCartorio: function (entrada) {
        if (entrada) {
          return entrada.split(" / ")[1];
        }
        return "";
      },
    },
    methods: {
      confirmaErroPush(){
        this.$refs['erroPush'].hide();
        this.$bvModal.show("modal-valida-email");
      },
      cancelaErroPush(){
        this.redirecionaPainel();
      },
      cancelaValidacaoEmail(acao){
        if(acao){
          this.redirecionaPainel();
        }
      },
      confirmaValidacaoEmail(acao){
        if(acao){
          this.keyModalValidaEmail++;
        }
      },
      async getDados() {
        const token = localStorage.getItem("jwtToken");
        const res = await API.get(`usuario/logado?token=${token}`);

        this.usuario.nome = res.data[0].nm_usuario;
        this.usuario.cpf_cnpj = res.data[0].nm_nr_cpfcnpj;
        this.usuario.celular = res.data[0].nm_nr_celular;
        this.usuario.telefone = res.data[0].nm_nr_telefone;
        this.usuario.email = res.data[0].nm_email;
        this.usuario.ic_email_validado = res.data[0].ic_email_validado;
        this.usuario.nm_email_atual = res.data[0].nm_email;

        return true
      },
      cancelar_pedido(row){
        alert
          this.cd_pedido_atual = row.cd_anuencia
          this.motivo_cancelamento = null
          this.mensagem = "Está ação é irreversível. <br><br> Deseja cancelar o Pedido: <b>" + this.cd_pedido_atual + "</b>"
          this.$refs['cancelar_pedido'].show();
        
      },
      redirecionaPainel(){
      this.$router.push({
        name: "painel",
      });
    },
      fechar_modal(){
        this.$refs['cancelar_pedido'].hide();
      },
      efetua_cancelamento_pedido(){
        this.carregando = true
        const token = localStorage.getItem('jwtToken')
        let self = this
        API.post(`anuencia/cancelar_pedido`, { token: token, cd_pedido: this.cd_pedido_atual, motivo:this.motivo_cancelamento }).then(() => {
          self.cd_pedido_atual = null
          self.motivo_cancelamento = null
          self.mensagem = null
          self.carregando = false
          self.$refs['cancelar_pedido'].hide();
          self.pesquisar()
  
        });
  
      },
      filtrarBusca(filtros){
        this.form = {
          nomeDevedor: (filtros.nm_devedor !== null && filtros.nm_devedor !== undefined ? filtros.nm_devedor : ''),
          docDevedor: (filtros.nm_nr_identificacao_devedor !== null && filtros.nm_nr_identificacao_devedor !== undefined ? filtros.nm_nr_identificacao_devedor : ''),
          nrTituloDevedor: (filtros.nm_nr_titulo !== null && filtros.nm_nr_titulo !== undefined ? filtros.nm_nr_titulo : ''),
          dtSolicitacao: (filtros.dt_cadastro !== null && filtros.dt_cadastro !== undefined ? filtros.dt_cadastro : ''),
        };
        this.pesquisar();
      },
      executarFuncao: function(funcao, linha){
        if (this[funcao]){
          this[funcao](linha)
        }
      },
      informacoesCertificado() {
        const cpfCertificado = localStorage.getItem("usrCpf"),
          nomeCertificado = localStorage.getItem("usrName");
  
        this.empresaCredora.push({
          value: cpfCertificado,
          text: `${nomeCertificado} - ${cpfCertificado}`,
        });
      },
      async pesquisar() {
        this.loading = true;
        const token = localStorage.getItem("jwtToken");
        await API.post("avise_me/exibir_avisos", {
          ...this.form,
          token: token,
        })
          .then((res) => {
            this.items = res.data;
            this.loading = false;
            if (!res.data.length) {
              this.erro.msg =
                "Não existem avisos ativos em seu CPF/CNPJ";
              this.erro.titulo = "Atenção";
              this.$refs.erro.show();
            }
          })
          .catch(() => {
            this.loading = false;
  
            this.erro.msg =
              "Não foi possível realizar a pesquisa, por favor, verifique se a sessão permanece ativa";
            this.erro.titulo = "Atenção";
            this.$refs.erro.show();
          });
      },
      baixarPDF: function (row) {
        let id = row.cd_anuencia
        this.loading = true;
        const token = localStorage.getItem("jwtToken");
        API.post("anuencia/pdfPedidoAnexo", {
          cd_anuencia_titulo: id,
          token,
        })
          .then((res) => {
            let dlnk = document.getElementById("dwnldLnk");
            dlnk.href = "data:application/pdf;base64," + res.data.dados.pdf;
            dlnk.click();
            if (res.data.dados.pdf_anexo != null) {
              this.baixarAnexoPdf(id, res.data.dados.pdf_anexo);
            }
            this.loading = false;
          })
          .catch(() => {
            alert("Falha ao realizar o Download");
            this.loading = false;
          });
      },
      baixarAnexoPdf(id, anexo) {
        let dwnldAnexo = document.getElementById("anexo");
        dwnldAnexo.href = "data:application/pdf;base64," + anexo;
        //setTimeout(function(){
        dwnldAnexo.click();
        // }, 1000);
      },
      resetarMsg() {
        this.erro.msg = "";
        this.erro.titulo = "";
      },
    },
  };
  </script>
  
  <style scoped>
  #wrapper-spinner {
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 100%;
    height: calc(100% - 80px);
  }
  
  #wrapper-spinner .v-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -10px 0px 0px -20px;
  }
  
  #painel {
    position: fixed;
    width: 100%;
    left: 0px;
    bottom: 0px;
    padding-top: 0px;
    height: calc(100% - 80px);
    background-color: #ffffff;
    overflow-x: hidden;
      border-top: 1px solid #f1f1f1;
  }
  
  .lista-certidoes {
    color: #000;
  }
  
  .lista-certidoes b {
    font-size: 0.85rem;
    color: var(--main-azul);
  }
  
  a {
    color: #555;
  }
  
  .shadow {
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  }
  
  #loading-solicitante {
    vertical-align: 0;
    margin-left: -21px;
  }
  
  .load {
    top: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .spin {
    background: #fff;
    height: 80px;
    width: 80px;
    border-radius: 50vh;
    border-color: #209cee;
    border-top: 5px solid #209cee;
    animation: loading 3s linear infinite;
  }
  
  .loading {
    position: absolute;
    color: #000;
    width: 100%;
    text-align: center;
  }
  
  @keyframes loading {
    100% {
      transform: rotate(360deg);
    }
  }
  
  .bold {
    font-weight: bold;
  }
  
  .mensagemErro {
    color: red;
  }
  
  #painel > .row{justify-content: space-between;}
  #painel{scrollbar-width:none;}
  #painel::-webkit-scrollbar{display:none;}
  .espaco-menu{width: calc(296px + 5px + 5px);flex: unset;margin-left: calc(3.8vw - 5px);}
  #painel h1 {text-align: left;font: normal normal bold 25px/41px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;margin-bottom: 33px;}
  
  #painelcontainerfluid{padding:0;padding-right: 3.8vw;margin-top: 37px;}
  #aviseme-erroPushModal .modal-btn-voltar {
    border:none;
    background-color: #FFFFFF;
    border: 3px solid transparent;
    color: #4780f1;
  }
  #aviseme-erroPushModal .modal-btn-voltar:hover{
    border: 3px solid #4780f1;
  }
  #aviseme-erroPushModal .modal-btn-prosseguir{
    border: 3px solid #597EB5;
    background: #ffffff;
    color: #597EB5;
  }
  #aviseme-erroPushModal .modal-btn-prosseguir:hover{
    border: 3px solid #4780f1;
    background: #4780f1;
    color: #ffffff;
  }

  @media (max-width:1600px) and (min-width:1400px){
    .espaco-menu{margin-left: calc(20px - 5px) !important;}  
    #painelcontainerfluid{padding-right: 20px !important;}
  }
  @media (max-width:1399px) and (min-width:1200px){
    .espaco-menu{margin-left: calc(10px - 5px) !important;}
    #painelcontainerfluid{padding-right: 10px !important;}
  }
  @media (max-width:1199px){
    #painel {padding:0 17px;}
    #painel > .row{
      width: 100%;
      max-width: none;
      margin: 0 !important;
      padding: 0px !important;
      margin-bottom: 70px !important;
    }
    .col-lg-9{max-width: none;flex: 1 1 100%;}
    #painel{padding:0px !important;}
    #painelcontainerfluid{padding:0px !important;}
  }
  </style>
  